module.exports = __webpack_public_path__ + "r-v3/img/ml_43_00.302e95a1.jpg";